import React from 'react';

const WalkSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M13.1 15.3L11 13.6V10c0-.6.5-1 1-1 .6 0 1 .5 1 1v5.3zm1-5.3c0-1.1-.9-2-2.1-2-.6 0-1.2.3-1.6.7L7 13.1l.8.6L9.9 11v3l5.2 4.3v3.4h1v-3.8L14 16.2V10zM15.9 12.4l-.7.7 2 1.9.7-.7z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M7.2 21.5l.9.5 3.5-5.3-.9-.6zM11.9 2c-1.4 0-2.5 1.1-2.5 2.5S10.5 7 11.9 7s2.5-1.1 2.5-2.5S13.3 2 11.9 2zm0 4c-.8 0-1.5-.7-1.5-1.5S11.1 3 11.9 3s1.5.7 1.5 1.5S12.7 6 11.9 6z"
        />
    </svg>
);

WalkSvg.displayName = 'WalkSvg';
export default WalkSvg;
